import myRequery from '/static/request.js'
import { baseUrl, prefix, netPrefix } from '/public/baseUrl'
/*登录接口
*/
export function userLogin(options) {
	return myRequery({
		url: 'api/nocheck/login',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

/**
 * 分页查询校区控制配置
 * {
	oid : "",
	pagesize : 10,
	pagenum : 1
 }
 * @param {Object} options
 */
export function queryControlPointSetByPage(options) {
	return myRequery({
		url: 'api/ctlpointset/queryOrgControlSettingByPage',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/**
 * 查询所有校区组织
 */
export function queryAllOrg(options) {
	return myRequery({
		url: 'api/org/queryAllOrgList',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/**
 * 查询校区设备
 * oid
 */
export function queryOrgDevList(options) {
	return myRequery({
		url: 'api/orgdev/queryDevByOrgid',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/**
 * 查询设备点位
 * did
 */
export function queryPropertyListByDev(options) {
	return myRequery({
		url: 'api/orgdev/queryDevPropertysBydid',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}
/**删除控制点
 * @param {Object} options
 * id
 */
export function deleteControlPointSet(options) {
	return myRequery({
		url: 'api/ctlpointset/deleteOrgControlSetting',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}
/**添加控制点设置
 * @param {Object} options
 * id
 */
export function addControlPointSet(options) {
	return myRequery({
		url: 'api/ctlpointset/addOrgControlSetting',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}
/**编辑控制点设置
 * @param {Object} options
 * id
 */
export function editControlPointSet(options) {
	return myRequery({
		url: 'api/ctlpointset/editOrgControlSetting',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

/**分页查询系统配置列表
 * @param {Object} options
 * pagesize
 * pagenum
 */
export function querySysConfigList(options) {
	return myRequery({
		url: 'api/config/querySysConfigByPage',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}
/**添加系统配置
 * @param {Object} options
 */
export function addSysConfig(options) {
	return myRequery({
		url: 'api/config/addSysConfig',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}
/**编辑系统配置
 * @param {Object} options
 */
export function eidtSysConfig(options) {
	return myRequery({
		url: 'api/config/editSysConfig',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}
/**删除系统配置
 * @param {Object} options
 * id
 */
export function deleteSysConfig(options) {
	return myRequery({
		url: 'api/config/deleteSysConfig',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}
/**根据父节点id查询组织
 */
export function queryOrgByParent(options) {
	return myRequery({
		url: 'api/org/queryOrgBypid',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}
/**添加组织
 */
export function addSysOrg(options) {
	return myRequery({
		url: 'api/org/addSysOrg',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}
/**编辑组织
 */
export function editSysOrg(options) {
	return myRequery({
		url: 'api/org/editSysOrg',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}
/**删除组织
id
 */
export function deleteOrgById(options) {
	return myRequery({
		url: 'api/org/deleteSysOrg',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/**查询组织树
 */
export function queryAllOrgTree(options) {
	return myRequery({
		url: 'api/org/queryAllOrgTree',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/**删除附件
filename
 */
export function deleteSysFile(options) {
	return myRequery({
		url: 'api/public/deletefile',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/**查询人员列表
name org pagesize pagenum
 */
export function querySysUserByPage(options) {
	return myRequery({
		url: 'api/sys/queryUsersByPage',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/**删除用户
id
 */
export function deleteSysUser(options) {
	return myRequery({
		url: 'api/sys/deleteUser',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/**查询用户角色
id
 */
export function queryUserRoles(options) {
	return myRequery({
		url: 'api/sys/queryUserRoles',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/**查询所有角色
 */
export function queryAllSysRoles(options) {
	return myRequery({
		url: 'api/sys/queryAllRoles',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/**分页查询角色
name pagesize pagenum
 */
export function queryRolesByPage(options) {
	return myRequery({
		url: 'api/sys/queryRolesByPage',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}
/**查询角色菜单权限
rid
 */
export function querySysRoleMenus(options) {
	return myRequery({
		url: 'api/sys/queryRoleMenus',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}
/**查询角色组织权限
rid
 */
export function querySysRoleOrgs(options) {
	return myRequery({
		url: 'api/sys/queryRoleOrgs',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/**查询菜单树
 */
export function querySysMenuTree(options) {
	return myRequery({
		url: 'api/sys/queryMenuTree',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/**分页查询设备
 */
export function queryDevByPage(options) {
	return myRequery({
		url: 'api/orgdev/queryDevByPage',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/**分页查询设备点位
 */
export function queryDevPointByPage(options) {
	return myRequery({
		url: 'api/orgdev/queryDevPointByPage',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/**添加设备
 */
export function addDev(options) {
	return myRequery({
		url: 'api/orgdev/addDev',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

/**修改设备
 */
export function editDev(options) {
	return myRequery({
		url: 'api/orgdev/editDev',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

/**删除设备
 */
export function deleteDev(options) {
	return myRequery({
		url: 'api/orgdev/deleteDev',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/**添加点位
 */
export function addDevPoint(options) {
	return myRequery({
		url: 'api/orgdev/addDevPoint',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

/**修改点位
 */
export function editDevPoint(options) {
	return myRequery({
		url: 'api/orgdev/editDevPoint',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

/**删除点位
 */
export function deleteDevPoint(options) {
	return myRequery({
		url: 'api/orgdev/deleteDevPoint',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/**分页查询位置列表
name oid pagesize pagenum
 */
export function querySysLocs(options) {
	return myRequery({
		url: 'api/sys/queryLocsByPage',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/**查询位置类型列表
 */
export function querySysLocTypes(options) {
	return myRequery({
		url: 'api/sys/queryLocTypes',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/**添加位置
 */
export function addSysLocation(options) {
	return myRequery({
		url: 'api/sys/addSysLocation',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

/**编辑位置
 */
export function editSysLocation(options) {
	return myRequery({
		url: 'api/sys/editSysLocation',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

/**删除位置
id
 */
export function deleteSysLocation(options) {
	return myRequery({
		url: 'api/sys/deleteSysLocationByOrg',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/**分页查询位置点位信息
 */
export function queryLocRelPointsByPage(options) {
	return myRequery({
		url: 'api/sys/queryLocRelPointsByPage',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}
/**删除位置点位
id
 */
export function deleteSLocationRelPoint(options) {
	return myRequery({
		url: 'api/sys/deleteSLocationRelPoint',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/**添加角色
id
 */
export function addSysRole(options) {
	return myRequery({
		url: 'api/sys/addSysRole',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

/**编辑角色
id
 */
export function editSysRole(options) {
	return myRequery({
		url: 'api/sys/editSysRole',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

/**删除角色
id
 */
export function deleteSysRole(options) {
	return myRequery({
		url: 'api/sys/deleteSysRole',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/**更新角色菜单权限
 */
export function updateSysRoleMenus(options) {
	return myRequery({
		url: 'api/sys/updateRoleMenus',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

/**更新角色组织权限
 */
export function updateSysRoleOrgs(options) {
	return myRequery({
		url: 'api/sys/updateRoleOrgs',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

/**分页查询计算点位信息
name pagesize pagenum
 */
export function queryCalcPointsByPage(options) {
	return myRequery({
		url: 'api/sys/queryCalcByPage',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/**分页查询组织关联的计算点位信息
oid pagesize pagenum
 */
export function queryOrgCalcPointsByPage(options) {
	return myRequery({
		url: 'api/sys/queryOrgCalcByPage',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/**添加计算点位信息
 */
export function addCalcPoint(options) {
	return myRequery({
		url: 'api/sys/addSysCalc',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

/**修改计算点位信息
 */
export function editCalcPoint(options) {
	return myRequery({
		url: 'api/sys/editSysCalc',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

/**删除计算点位信息
id 
 */
export function deleteCalcPoint(options) {
	return myRequery({
		url: 'api/sys/deleteSysCalc',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/**删除组织关计算点位关联
id 
 */
export function deleteOrgCalcRel(options) {
	return myRequery({
		url: 'api/sys/deleteOrgCalc',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}
/**添加组织计算点位关联
 */
export function addOrgCalcRel(options) {
	return myRequery({
		url: 'api/sys/addOrgCalc',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}
/**更新组织计算点位关联
 */
export function editOrgCalcRel(options) {
	return myRequery({
		url: 'api/sys/editOrgCalc',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

/**添加位置点位关联
 */
export function addLocPointCalc(options) {
	return myRequery({
		url: 'api/sys/addLocPointCalc',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

/**查询报表配置点位列表
 */
export function queryHisPowerSetByPage(options) {
	return myRequery({
		url: 'api/sys/queryHisPowerSetByPage',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/**添加报表配置点位
 */
export function addHisPowerSet(options) {
	return myRequery({
		url: 'api/sys/addHisPowerSet',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

/**更新报表配置点位
 */
export function editHisPowerSet(options) {
	return myRequery({
		url: 'api/sys/editHisPowerSet',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

/**删除报表配置点位 
id
 */
export function deleteHisPowerSet(options) {
	return myRequery({
		url: 'api/sys/deleteHisPowerSet',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/**查询组织下所有设备点位
oid
 */
export function queryOrgAllPropertys(options) {
	return myRequery({
		url: 'api/orgdev/queryOrgAllPropertys',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/**查询多个点位
ids
 */
export function queryMutilPropertys(options) {
	return myRequery({
		url: 'api/orgdev/queryMutilPropertys',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

/**查询报表列表
 */
export function queryHisPowerByPage(options) {
	return myRequery({
		url: 'api/report/queryReportByPage',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/**更新报表数据
 */
export function editHisPower(options) {
	return myRequery({
		url: 'api/report/editReport',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

/**更新报表数据
 */
export function addHisPower(options) {
	return myRequery({
		url: 'api/report/addReport',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

/**查询报表配置
 */
export function queryHisPowerset(options) {
	return myRequery({
		url: 'api/sys/queryHisPowerSetByOrgId',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/**删除报表
 */
export function deleteHisPower(options) {
	return myRequery({
		url: 'api/report/deleteReport',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/**统计校区房间空调不同模式时间
 */
export function querySchoolAirOpens(options) {
	return myRequery({
		url: 'api/report/orgAirTimes',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}
export function querySchoolAirOpensHour(options) {
	return myRequery({
		url: 'api/report/orgAirTimesHour',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/**统计房间空调日期下模式开启时间
 */
export function queryRoomAirOpens(options) {
	return myRequery({
		url: 'api/report/roomDayAirTimes',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}


/**查询点位历史数据
 */
export function queryPointsHis(options) {
	return myRequery({
		url: 'api/report/queryPointsHis',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

/**查询点位历史数据
 */
export function queryOffLineAirs(options) {
	return myRequery({
		url: 'api/orgdev/queryOfflines',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/***/
export function queryRoomControl(options) {
	return myRequery({
		url: 'api/orgdev/queryRoomControlByPage',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/** */
export function syncRoomControl(options) {
	return myRequery({
		url: 'api/orgdev/syncRoomControl',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

export function autoCreateOrgCacl(options) {
	return myRequery({
		url: 'api/orgdev/autoCreateCaclPoint',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

export function syncDevPointFromGather(options) {
	return myRequery({
		url: 'api/orgdev/syncDevPointFrom',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

export function deleteSchoolRoomControl(options) {
	return myRequery({
		url: 'api/orgdev/deleteRoomControlBySchool',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

/**批量删除位置
id
 */
export function deleteSysLocationMutil(options) {
	return myRequery({
		url: 'api/sys/deleteSysLocationByMutil',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

//分页查询实际设备
export function queryRealDevPage(options){
	return myRequery({
		url: 'api/org/queryRealDevByPage',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

//分页查询实际设备属性
export function queryRealDevPointsPage(options){
	return myRequery({
		url: 'api/org/queryRealDevPointByPage',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

//添加实际设备
export function addRealDev(options){
	return myRequery({
		url: 'api/org/addRealDev',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

//修改实际设备
export function editRealDev(options){
	return myRequery({
		url: 'api/org/editRealDev',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

//删除实际设备
export function deleteRealDev(options){
	return myRequery({
		url: 'api/org/deleteRealDev',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

//批量删除实际设备
export function deleteRealDevMulti(options){
	return myRequery({
		url: 'api/org/deleteRealDevMulti',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

//添加实际设备点位
export function addRealDevPoint(options){
	return myRequery({
		url: 'api/org/addRealDevPoint',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}
//修改实际设备点位
export function editRealDevPoint(options){
	return myRequery({
		url: 'api/org/editRealDevPoint',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}
//删除实际设备点位
export function deleteRealDevPoint(options){
	return myRequery({
		url: 'api/org/deleteRealDevPoint',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

//查询位置关联的实际设备
export function queryLocRealDev(options){
	return myRequery({
		url: 'api/org/queryLocRealDevByPage',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

//添加位置和实际设备关联
export function addLocRelRealDev(options){
	return myRequery({
		url: 'api/org/addRealDevRelLoc',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

//删除实际设备点位
export function deleteLocRealDev(options){
	return myRequery({
		url: 'api/org/deleteRealDevRelLoc',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}
//查询实际设备
export function queryRealDevById(options){
	return myRequery({
		url: 'api/org/queryRealDev',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

//分页查询实际设备类型
export function queryRealDevTypeByPage(options){
	return myRequery({
		url: 'api/config/queryDevTypeByPage',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}
//分页查询实际设备型号
export function queryRealDevModelByPage(options){
	return myRequery({
		url: 'api/config/queryDevModelByPage',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}

//添加实际设备类型
export function addRealDevType(options){
	return myRequery({
		url: 'api/config/addDevType',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}
//添加实际设备型号
export function addRealDevModel(options){
	return myRequery({
		url: 'api/config/addDevModel',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}
//修改实际设备类型
export function editRealDevType(options){
	return myRequery({
		url: 'api/config/editDevType',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}
//修改实际设备型号
export function editRealDevModel(options){
	return myRequery({
		url: 'api/config/editDevModel',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}
//查询全国城市校区数量
export function queryCitySchoolNum(options){
	return myRequery({
		url: 'api/config/queryCitySchoolNum',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}
//按校区创建空调内机逻辑设备
export function autoCreateAirIn(options){
	return myRequery({
		url: 'api/sys/createAirInByOrg',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}
//分页查询位置类型
export function queryLocTypePage(options){
	return myRequery({
		url: 'api/config/queryLocTypeByPage',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}
//添加位置类型
export function addLocType(options){
	return myRequery({
		url: 'api/config/addLocType',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}
//编辑位置类型
export function editLocType(options){
	return myRequery({
		url: 'api/config/editLocType',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}

//重启采集器
export function restartGatherDocker(options){
	return myRequery({
		url: 'api/sys/restartGather',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}
//分页查询控制器充值记录
export function queryControllerRechargeRecords(options){
	return myRequery({
		url: 'api/controllerRecord/queryControllerRecordByPage',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}
//修改控制器充值记录
export function editControllerRechargeRecords(options){
	return myRequery({
		url: 'api/controllerRecord/editControllerRecord',
		method: 'POST',
		prefix: prefix,
		data: options,
	})
}
//删除控制器充值记录
export function deleteControllerRechargeRecords(options){
	return myRequery({
		url: 'api/controllerRecord/deleteControllerRecord',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}
//同步查询控制器充值记录
export function asyncControllerRecord(options){
	return myRequery({
		url: 'api/controllerRecord/asyncControllerRecord',
		method: 'GET',
		prefix: prefix,
		data: options,
	})
}
//查询城市列表
export function queryCityList(options){
	console.log(netPrefix)
	return myRequery({
		url: netPrefix+'/api/city/UsingCity',
		method: 'POST',
		prefix: netPrefix,
		data: options,
		nobase: true,
	})
}
